// extracted by mini-css-extract-plugin
module.exports = {"card_section":"See_card_section__2ArPF","card_section_title":"See_card_section_title__3oogd"};